import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { FormFieldsContainer } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../Formik'
import { LABEL_ENTITY_VALUE, LabelFormField } from '../../../Label'
import {
  REQUEST_EDIT_LABEL_FORM_INITIAL_VALUES,
  REQUEST_EDIT_LABEL_FORM_LABEL_FIELD,
} from '../RequestEditLabelModal.constants'

function RequestEditLabelModalFields({
  actionTypes,
  entity = LABEL_ENTITY_VALUE.request,
  isLoading,
}) {
  const { t } = useTranslation()

  const { errors } = useFormikContext()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: REQUEST_EDIT_LABEL_FORM_INITIAL_VALUES,
    })

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          error: errors[REQUEST_EDIT_LABEL_FORM_LABEL_FIELD],
          options: actionTypes,
        }}
      >
        <LabelFormField
          disabled={actionTypeValueIsRemoveAll}
          entity={entity}
          fieldComponentProps={{
            isLoading,
            label: `${t('Request.EditLabelFormLabelFieldLabelKey')}:`,
          }}
          name={REQUEST_EDIT_LABEL_FORM_LABEL_FIELD}
          placeholder={t('Request.EditLabelFormLabelFieldPlaceholderKey')}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default RequestEditLabelModalFields
